// extracted by mini-css-extract-plugin
export default {"full-page-loader":"full-page-loader_full-page-loader__zkVdd"};